import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=03f812ae&"
import script from "./Storage.vue?vue&type=script&lang=js&"
export * from "./Storage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports